<app-terms></app-terms>
<app-page-loader #spinnerElement [showLoader$]="showpageLoader$"></app-page-loader>
<router-outlet></router-outlet>
